import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@/shared/components/MaterialTableElements';
import { RootState } from '@/stores';

const rows = [
    {
        id: 'id',
        disablePadding: true,
        label: 'id',
    },
    {
        id: 'title',
        disablePadding: false,
        label: 'Title',
    },
    {
        id: 'category',
        disablePadding: false,
        label: 'Category',
    },
    {
        id: 'personas',
        disablePadding: false,
        label: 'Personas',
    },
    {
        id: 'mediaType',
        disablePadding: false,
        label: 'Media Type',
    },
    {
        id: 'subscriptionPlan',
        disablePadding: false,
        label: 'Subscription Plan',
    },
    {
        id: 'created_at',
        disablePadding: false,
        label: 'Created At',
    },
    {
        id: 'updated_at',
        disablePadding: false,
        label: 'Updated At',
    },
];

interface MatTableHeadProps {
    // numSelected: number,
    // rowCount: number,
    // onSelectAllClick: ()=>void,
    onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
    order: 'asc' | 'desc';
    orderBy: string;
}

const MatTableHead = ({
    //  onSelectAllClick,
    order,
    orderBy,
    //  numSelected, rowCount,
    onRequestSort,
}: MatTableHeadProps) => {
    const rtl = useSelector((state: RootState) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {/* <TableCell padding="checkbox">
                    <TableCheckbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={numSelected === rowCount}
                        onChange={onSelectAllClick}
                    />
                </TableCell> */}
                {rows.map((row) => (
                    <TableCell
                        key={row.id}
                        align={rtl.direction === 'rtl' ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === row.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={(event) => onRequestSort(event, row.id)}
                            className="material-table__sort-label"
                            dir="ltr"
                        >
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
